import React from 'react';
import { motion } from 'framer-motion';
import { Scale, ThermometerSun, Moon, BrainCircuit, Battery, Frown, CalendarClock, Heart } from 'lucide-react';
export function SymptomsSection() {
  const symptoms = [{
    icon: <Scale size={32} data-id="element-183" />,
    title: 'Grasa Abdominal',
    desc: 'Aumento de peso concentrado en la cintura, resistente a dietas.'
  }, {
    icon: <ThermometerSun size={32} data-id="element-184" />,
    title: 'Bochornos',
    desc: 'Oleadas de calor repentinas e incontrolables durante el día.'
  }, {
    icon: <Moon size={32} data-id="element-185" />,
    title: 'Insomnio',
    desc: 'Dificultad para dormir o sudores nocturnos que interrumpen el descanso.'
  }, {
    icon: <BrainCircuit size={32} data-id="element-186" />,
    title: 'Niebla Mental',
    desc: 'Falta de concentración, olvidos frecuentes y confusión leve.'
  }, {
    icon: <Battery size={32} data-id="element-187" />,
    title: 'Cansancio Crónico',
    desc: 'Agotamiento profundo que no mejora ni siquiera descansando.'
  }, {
    icon: <Frown size={32} data-id="element-188" />,
    title: 'Irritabilidad',
    desc: 'Cambios de humor bruscos, ansiedad o tristeza sin razón aparente.'
  }, {
    icon: <CalendarClock size={32} data-id="element-189" />,
    title: 'Cambios de Ciclo',
    desc: 'Periodos irregulares, más cortos, más largos o más abundantes.'
  }, {
    icon: <Heart size={32} data-id="element-190" />,
    title: 'Baja Libido',
    desc: 'Disminución del deseo sexual y cambios en la respuesta física.'
  }];
  return <section className="py-20 px-4 bg-primary-bg" data-id="element-191">
      <div className="max-w-6xl mx-auto" data-id="element-192">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-4xl mx-auto" data-id="element-193">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-text-primary mb-6 leading-tight" data-id="element-194">
            Si te está pasando esto, tu cuerpo no te está traicionando…{' '}
            <span className="text-health underline decoration-accent/50 underline-offset-4" data-id="element-195">
              te está pidiendo ayuda distinta
            </span>
          </h2>
          <p className="text-lg text-text-primary/70" data-id="element-196">
            Estos no son "achaques de la edad" que debas soportar en silencio.
            Son señales de que tu metabolismo necesita un nuevo manual de
            instrucciones.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-197">
          {symptoms.map((symptom, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white p-6 rounded-2xl shadow-md border border-text-primary/5 hover:shadow-xl hover:border-accent/30 transition-all group" data-id="element-198">
              <div className="w-14 h-14 rounded-xl bg-primary-contrast flex items-center justify-center text-health group-hover:bg-health group-hover:text-white transition-colors mb-4" data-id="element-199">
                {symptom.icon}
              </div>
              <h3 className="text-xl font-bold text-text-primary mb-2" data-id="element-200">
                {symptom.title}
              </h3>
              <p className="text-text-primary/70 text-sm leading-relaxed" data-id="element-201">
                {symptom.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}